import { cardSrc } from './resultParsers';

const PLAYERS = ['Player A', 'Player B', 'Player C', 'Player D'];

// Race to 2nd result — left col-lg-8: har player (col-lg-12, stacked) →
// casino-result-cards: h4 name + card item; winner player ke card ke BAAD ek aur
// casino-result-cards-item me winner.png (winner-icon). Right col-lg-4: Winner desc.
export default function Race2Result({ detail }) {
  const cards = (detail?.card || '').split(',').map((s) => s.trim()).filter(Boolean);
  const winner = detail?.winnat || '';

  return (
    <div className="row row5 card32result">
      <div className="col-12 col-lg-8">
        <div className="row row5">
          {PLAYERS.map((name, i) => {
            const isWinner = winner === name;
            return (
              <div key={i} className="col-12 col-lg-12">
                <div className="casino-result-cards">
                  <h4 className="text-center d-inline-block">{name}</h4>
                  {' '}
                  <div className="casino-result-cards-item">
                    <img src={cardSrc(cards[i])} alt={cards[i] || ''} />
                  </div>
                  {' '}
                  {isWinner && (
                    <div className="casino-result-cards-item">
                      <img src="https://wver.sprintstaticdata.com/v230/static/front/img/winner.png" className="winner-icon" alt="Winner" />
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="col-12 col-lg-4">
        <div className="casino-result-desc">
          <div className="casino-result-desc-item">
            <div>Winner</div>
            {' '}
            <div>{winner}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
